import { mapGetters, mapActions } from 'vuex'

export const documentTypeStoreActions = {
  ...mapActions('documentTypeStore', [
    'getDocumentsType',
    'createDocumentType',
    'updateDocumentType',
    'deleteDocumentType'
  ])
}

export const documentTypeStoreData = {
  ...mapGetters('documentTypeStore', [
    'documentsType',
    'documentsTypeItemKey',
    'documentsTypeItemText',
    'documentTypeHeaders',
    'isDocumentsTypeBusy',
    'documentsTypeLoadingText',
    'documentsTypeNoDataText',
    'documentTypeDeleteLabels',
    'documentTypeVisibilityTrueLabels',
    'documentTypeVisibilityFalseLabels',
    'documentsTypeLimitExceededLabel',
    'isExceeded',
    'msgDocumentTypeServiceError',
    'msgDocumentTypeServicePutError',
    'msgDocumentTypeServiceDeleteError'
  ])
}
